export default "__VITE_ASSET__fVqYq_qL__"